<template>
	<div
		 class="c-global-search__popup"
		 :class="{ 'active' : showSearchPopup, 'visible-results' : searchAutocompleteResultsVisible }"
		 ref="GlobalSearchPopup"
		 :style="`--global-search-popup-top: ${this.top}px`"
		 @click="togglePopup"
		 data-testid="global-search-popup"
		 @keydown.down.prevent="handleAscSuggestion"
		 @keydown.up.prevent="handleDescSuggestion"
		 @keydown.esc.prevent="handleCancelAutosuggestionSearch"
		 @afterLeave="restoreFocus"
		 role="dialog"
		 aria-modal="true"
		 >
		<div class="c-global-search__popup-wrapper" @click.stop>
			<div class="c-global-search__popup-stickybox">
				<global-search-field
					@autosuggestsearch="autoSuggestSearch"
					@search="handleSearch"
					@shortcodesearch="shortCodeSearch"
					@reset="handleCancelAutosuggestionSearch"
					ref="searchField"
					:aria-labels="{
						search: vm.BaseViewModel?.SearchIconAriaLabel,
						clear: vm.BaseViewModel?.ClearSearchIconAriaLabel,
						field: vm.BaseViewModel?.SearchFieldAriaLabel,
					}"
					/>

				<DsIconButton
					v-if="!isGlobalNav"
					class="h-visible-up-from-medium"
					icon-name="close"
					variant="ghost-neutral"
					:ariaLabel="vm.BaseViewModel?.CloseSearchAriaLabel || 'Close Search Overlay'"
					tabindex="0"
					size="md"
					:click-handler="() => {togglePopup()}"
				/>

			</div>
			<global-search-autoSuggest-dropDown-list v-if="localSearchPhrase.length" />
		</div>
	</div>
</template>
<script>
import globalSearchAutosuggestResultsMixin from 'shared/mixins/globalSearchAutosuggestResultsMixin';
import GlobalSearchField from 'shared/components/globalSearch/globalSearchField.vue';
import GlobalSearchAutoSuggestDropDownList from 'shared/components/globalSearch/globalSearchAutosuggestDropDownList.vue';
import { DsIconButton } from "@coloplast/design-system";
import { mapGetters, mapMutations } from 'vuex';
import useModalFocusTrap from 'shared/composables/focusTrap';
import * as _ from 'lodash';

export default {
	name: 'global-search-popup',
	mixins: [globalSearchAutosuggestResultsMixin],
	props: {
		vm: {
			type: Object,
		},
		isGlobalNav: {
			type: Boolean,
		},
	},
	components: {
		GlobalSearchField,
		GlobalSearchAutoSuggestDropDownList,
		DsIconButton
	},
	data: function () {
		return {
			top: 0,
			popup: null,
			notStickyMenu: null,
			restoreFocus: null,
		}
	},
	created() {
		if (!_.isEmpty(this.vm)) {
			this.setGlobalSearchModel(this.vm.BaseViewModel);
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.popup = this.$refs.GlobalSearchPopup;
			this.notStickyMenu = document.querySelector('.enrollment-nav') || document.querySelector('.sticky-disabled');
		});

		document.addEventListener("activateSearchPopup", () => {
			this.restoreFocus = useModalFocusTrap(this.$refs.GlobalSearchPopup, this.togglePopup, '', true).restoreFocus;
		});
	},
	computed: {
		...mapGetters({
			autoSuggestSearchPhrase: 'getAutoSuggestSearchPhrase',
			globalSearchModel: 'getGlobalSearchModel',
			showSearchPopup: 'getShowSearchPopup',
		}),
	},
	watch: {
		showSearchPopup(newVal) {
			if (newVal) {
				const searchField = this.$refs.GlobalSearchPopup.querySelector('.c-global-search__field');
				if (searchField != null) {
					setTimeout(() => {
						searchField.focus();
					}, 0);
				}
				if (!this.isGlobalNav) {
					document.documentElement.classList.add("nav-search-popup");
					const event = new CustomEvent("activateSearchPopup", {});
					document.dispatchEvent(event);
				}
			}
			else if (!this.isGlobalNav) {
				document.documentElement.classList.remove("nav-search-popup");
			}
		},
	},
	methods: {
		...mapMutations([
			'setGlobalSearchModel',
			'setShowSearchPopup',
		]),
		handleSearch() {
			this.executeSearch();
		},
		setTopPopupPosition() {
			//the rest window.headerHeight calculation is in src/shared/vanilla/stickyMenu.js
			if (this.notStickyMenu != null && !this.isGlobalNav) {
				const position = this.notStickyMenu.getBoundingClientRect();
				if (position.top >= 0 && position.bottom <= window.innerHeight)
					window.headerHeight = position.height;
				else
					window.headerHeight = 0;
			}
			this.top = `${window.headerHeight}px`;
			if (this.popup != null)
				this.popup.setAttribute('style', `top: ${this.top}; height: calc(100% - ${this.top})`);
		},
		togglePopup() {
			this.setShowSearchPopup();
			this.cancelAutosuggestionSearch();
			this.searchField.reset();
		},
		handleCancelAutosuggestionSearch() {
			this.cancelAutosuggestionSearch();
			this.$nextTick(() => {
				this.setSearchInputFocus();
			});
		}
	}
};
</script>
